<template>
  <icon v-if="sportName"
        :name="'icon-' + sportName"
        :colorName="colorName">
  </icon>
</template>

<script>
import lib from '@/library'
import Icon from '@/components/common/Icon'
import Brands from '@/components/mixins/Brands'

export default {
  name: 'SportIcon',

  components: {
    Icon
  },

  mixins: [
    Brands
  ],

  data () {
    return {
    }
  },

  props: {
    event
  },

  computed: {
    sportName () {
      let name = ''

      if (this.manyEvents()) {
        if (this.allEventsSameLeague()) {
          name = this.isLeagueValidForIcon(this.event[0]) ? this.event[0].sportname : this.processSportType(this.event[0])
        } else if (this.allEventsSameSport()) {
          name = this.processSportType(this.event[0])
        } else {
          name = ''
        }
      } else {
        if (this.isLeagueValidForIcon(this.event)) {
          name = this.event.sportname
        } else {
          name = this.processSportType(this.event)
        }
      }

      return name.toUpperCase().replace(/ /g, '')
    },

    colorName () {
      return (this.brand_white1 || this.brand_translux5) ? 'white1' : 'white'
    }
  },

  methods: {
    manyEvents () {
      let result = false

      if (this.event && Array.isArray(this.event)) {
        result = true
      }

      return result
    },

    allEventsSameSport () {
      if (this.manyEvents()) {
        return lib.betting.event.areSameBy(this.event, ['idfosporttype'])
      } else {
        return Boolean(this.event)
      }
    },

    allEventsSameLeague () {
      if (this.manyEvents()) {
        return lib.betting.event.areSameBy(this.event, ['idfosporttype', 'sportname'])
      } else {
        return Boolean(this.event)
      }
    },
    // Check if we have this icon
    isLeagueValidForIcon (event) {
      let validLeagues = [
        'NBA',
        'NHL',
        'MLB',
        'NFL'
      ]

      return validLeagues.indexOf(event.sportname.toUpperCase()) > -1
    },
    // return idfosporttype except its NFL
    processSportType (event) {
      let result = ''
      let sportName = event.idfosporttype.toUpperCase()
      let leagueName = event.sportname.toUpperCase()

      if (sportName === 'NFL') {
        switch (leagueName) {
          case 'NFL':
          case 'PRO FOOTBALL':
            result = 'NFL'
            break
          default:
            result = 'FOOTBALL'
        }
      } else {
        result = event.idfosporttype
      }

      return result.toUpperCase().replace(/ /g, '')
    }

  },

  created () {

  },

  mounted () {

  }
}
</script>

<style scoped lang="stylus">
  @import "~@/css/config"


</style>



// WEBPACK FOOTER //
// src/components/common/SportIcon.vue